import {
  SET_DATA_ROLES,
  SET_DATA_ROLES_LOADING_STATE,
  UPDATE_DATA_ROLES,
  DELETE_DATA_ROLES,
  BULK_UPDATE_DATA_ROLES,
  BULK_DELETE_DATA_ROLES,
} from '@/store/modules/data-governance/mutation-types';

export default {
  [SET_DATA_ROLES_LOADING_STATE](state, payload) {
    state.dataRoles.isLoading = payload;
  },
  [SET_DATA_ROLES](state, payload) {
    state.dataRoles.data = payload;
  },
  [UPDATE_DATA_ROLES](state, payload) {
    const index = state.dataRoles.data.findIndex(role => role.tagGuid === payload.tagGuid);
    if (index !== -1) {
      state.dataRoles.data.splice(index, 1, payload);
    }
  },
  [DELETE_DATA_ROLES](state, payload) {
    const index = state.dataRoles.data.findIndex(role => role.tagGuid === payload);
    if (index !== -1) {
      state.dataRoles.data[index].owners = [];
      state.dataRoles.data[index].governors = [];
      state.dataRoles.data[index].stewards = [];
    }
  },
  [BULK_UPDATE_DATA_ROLES](state, payload) {
    payload?.items?.forEach(payloadItem => {
      const index = state.dataRoles.data.findIndex(role => role.tagGuid === payloadItem?.tagGuid);
      if (index !== -1) {
        const existing = state.dataRoles.data[index];
        // Only update the role if the value in payload.roles is not empty array
        if (payload?.roles?.owners?.length) {
          existing.owners = payload.roles.owners;
        }
        if (payload?.roles?.governors?.length) {
          existing.governors = payload.roles.governors;
        }
        if (payload?.roles?.stewards?.length) {
          existing.stewards = payload.roles.stewards;
        }
        state.dataRoles.data.splice(index, 1, existing);
      }
    });
  },
  [BULK_DELETE_DATA_ROLES](state, payload) {
    payload?.forEach(payloadTag => {
      const index = state.dataRoles.data.findIndex(role => role.tagGuid === payloadTag);
      if (index !== -1) {
        state.dataRoles.data[index].owners = [];
        state.dataRoles.data[index].governors = [];
        state.dataRoles.data[index].stewards = [];
      }
    });
  },
};